import { render } from "./ProjectSettings.vue?vue&type=template&id=e83eae8a&scoped=true"
import script from "./ProjectSettings.vue?vue&type=script&lang=js"
export * from "./ProjectSettings.vue?vue&type=script&lang=js"

import "./ProjectSettings.vue?vue&type=style&index=0&id=e83eae8a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e83eae8a"]])

export default __exports__